import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, Col } from "reactstrap";
import CardHoc from "../../Hoc/cardHoc";
import { Tabela, FiltrosCiclo } from '../../Basicos';
import { axiosApi } from '../../Basicos/axiosInstances';
import MenuTable from '../../Menu/menuTable';
import ModalGruposAlunoServico from '../../Basicos/Modal/GruposAlunoServico/ModalGruposAlunoServico';
import { connect } from 'react-redux';
import * as actionsRedux from '../../Store/Actions/index';
import ModalCiclo from '../../Basicos/Modal/Ciclo/ModalCiclo';

function montarColunas({ editar, deletar }, removerOnClick, editarOnClick, openModal, confirmaChamaDeleta) {
    let campos2 = [{ label: "Título", name: 'titulo' }, { label: 'Semestre', name: 'semestre.descricao' }, { label: 'Turma', name: 'turma.descricao' }, { label: 'Tipo de Atividade', name: 'tipo_atividade.nome' }]
    const colunas = campos2.map((elemento) => {
        switch (elemento.name) {
            case "cor":
                return {
                    Header: elemento.label,
                    Cell: ({ row }) => (
                        <div style={{ background: row.original.cor, width: -1, height: 32, borderRadius: 100 }} />)
                };

            default:
                return {
                    Header: elemento.label,
                    accessor: elemento.name,
                }
        }
    });

    if (editar || deletar) {
        colunas.push({
            Cell: ({ row }) => (
                <MenuTable
                    iconEdit={editar}
                    iconRemover={deletar}
                    removerOnClick={() => confirmaChamaDeleta(row.original.id)}
                    editarOnClick={() => openModal(row.original.id)}
                />
            ),
            resizable: false,
            accessor: "acoes",
            style: { width: 64 }
        });
    }
    return colunas;
}

function CardCiclo({
    ativarAlert,
    ativar,
    ativarCofirmacao,
    subFuncionalidade: {
        descricao,
        campos,
        acoes
    },
}) {
    const [isLoading, setIsLoading] = useState(true);
    const [ciclos, setCiclos] = useState([]);
    const [dadosFiltrados, setDadosFiltrados] = useState([]);
    const [filtros, setFiltros] = useState({});
    const [valoresFiltro, setValoresFiltro] = useState({
        periodo_letivo_id: undefined,
        semestre_id: undefined,
        turma_id: undefined
    });
    const [cicloId, setCicloId] = useState();
    const [dadosForm, setDadosForm] = useState({
        descricao: '',
        data: ''
    });
    const [modal, setModal] = useState(false);

    useEffect(() => {
        getGruposAlunoServico();
    }, []);

    useEffect(() => {
        let filtrados = ciclos;

        // Nota: Filtro de período letivo adicionado conforme solicitado, embora o dado Ciclo não possua periodo_letivo_id diretamente
        if (valoresFiltro.periodo_letivo_id) {
            // filtrados = filtrados.filter(d => d.periodo_letivo_id === valoresFiltro.periodo_letivo_id);
        }
        if (valoresFiltro.semestre_id) {
            filtrados = filtrados.filter(d => d.semestre_id === valoresFiltro.semestre_id);
        }
        if (valoresFiltro.turma_id) {
            filtrados = filtrados.filter(d => d.turma_id === valoresFiltro.turma_id);
        }

        setDadosFiltrados(filtrados);
    }, [valoresFiltro, ciclos]);

    const getGruposAlunoServico = async () => {
        setIsLoading(true)
        try {
            const { data } = await axiosApi.get('/auxiliares/ciclo')
            setCiclos(data.dados)
            setFiltros(data.filtros)
            setIsLoading(false)
        } catch (error) {
            console.log(error)
            if (error.response.status === 403) {
                ativarAlert(400, error?.response?.data?.mensagem);
            }

        }
    }

    const removerOnClick = async (id) => {
        setIsLoading(true)
        try {
            await axiosApi.delete(`/auxiliares/feriado/${id}`);
            setCiclos(prev => prev.filter(el => el.id !== id));
            ativarAlert('remover', 'sucesso')
        } catch (error) {
            ativarAlert('remover', 'error')
            console.log(error)
        }
        setIsLoading(false)
    }

    const alterarOnClick = (id) => {
        const elemento = ciclos.find((element) => element.id === id);
        setDadosForm(elemento);
    }

    const openModal = (id = null) => {
        setCicloId(id);
        setModal(true);
    }

    const closeModal = () => {
        setModal(false);
    }

    const chamaDeleta = async (id) => {
        setIsLoading(true)
        try {
            await axiosApi.delete(`/auxiliares/ciclo/${id}`);
            setCiclos(prev => prev.filter(el => el.id !== id));
            ativar('remover', 'sucesso')
        } catch (error) {
            ativar('remover', 'error')
            console.log(error)
        }
        setIsLoading(false)
    }

    const confirmaChamaDeleta = (id) => {
        ativarCofirmacao({
            titulo: 'Deletar',
            mensagem: 'Deseja deletar?',
            callback: chamaDeleta(id)
        })
    }

    const colunas = React.useMemo(() => montarColunas(acoes, chamaDeleta, alterarOnClick, openModal, confirmaChamaDeleta), [ciclos])
    return (
        <Fragment>
            <Col xs={12} sm={12} md={5} lg={6} xl={7} className="d-flex mb-3 header-legenda text-header">
                <h3><strong> {descricao?.toUpperCase()} </strong></h3>
            </Col>
            <Col xs={12} sm={12} md={7} lg={6} xl={5} className="header-acoes mb-3">
                <div id="pesquisar-wrap"></div>
                {/* <Button className="mx-3" onClick={() => openModal()}>Novo</Button> */}
            </Col>

            <FiltrosCiclo
                novoOnClick={() => openModal()}
                filtros={filtros}
                dados={ciclos}
                setDadosFiltrados={setDadosFiltrados}
                valoresFiltro={valoresFiltro}
                setValoresFiltro={setValoresFiltro}
            />

            <Tabela
                pesquisarGlobal={false}
                columns={colunas}
                data={dadosFiltrados}
            />
            <ModalCiclo
                isOpen={modal}
                setIsOpen={closeModal}
                setCiclos={setCiclos}
                cicloId={cicloId}
            />
        </Fragment>
    );
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
        ativarCofirmacao: (obj) => dispatch(actionsRedux.ativarModalConfirm(obj)),
        atualizarDadosRemotamente: () => dispatch(actionsRedux.atualizarSubFuncionalidade(ownProps.funcionalidade, ownProps.indiceSubFuncionalidade)),
    }
}

const mapStateToProps = (state) => {
    return {
        estruturaModal: state.subFuncionalidades.estruturaModal,
        estadoModal: state.subFuncionalidades.estadoModal,
    }
}

export default connect(null, mapDispatchToProps)(CardHoc(CardCiclo));
